import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Button, Radio, Space, Typography, Select, Modal, message, Tag } from 'antd';

import Api from "../../../api";
import SelfTable from "../../../components/SelfTable"
import {pagingParam} from "../../../utils/defaultValue";
import BackIcon from "../../../components/BackIcon/index";
import {ModalConfirm, getSearchParams} from '../../../utils/tool'

import './index.scss'

const { Link } = Typography;
const { TextArea } = Input;

const Dict = () => {
    
    const [form] = Form.useForm();
    const [addForm] = Form.useForm();

    // 分页
    const [pagination, setPagination] = useState({
        "pageIndex": 0,
        "pageSize": 0,
        "total":0
    });

    const [operationData, setOperationData] = useState({});

    // 列表数据
    const [listData, setListData] = useState([]);

    // 当前正在操作的数据KEY
    const [editingKey, setEditingKey] = useState('');

    const [tableLoading, setTableLoading] = useState(false);

    // 列表选择数据
    const [selectedRowKey, setSelectedRowKey] = useState([]);

    // 查询数据
    const [searchData, setSearchData] = useState({});

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);

    const [allDict, setAllDict] = useState([]);

    const columns = [
        {
            title: "字典编码",
            dataIndex: 'dictCode',
            width:'100px',
          },
          {
            title: "字典标签",
            dataIndex: 'dictLabel',
            render: (text, record) => {
              return record.listClass ? (<Tag color={record.listClass}>{text}</Tag>) : text;
            },
          },

          
          {
            title: "字典键值",
            dataIndex: 'dictValue',
          },
          {
            title: "字典排序",
            dataIndex: 'dictSort',
          },
          {
            title: "状态",
            dataIndex: 'status',
            width:'100px',
            render: (_, record) => {
              return (<Tag color={record.status == 0 ? 'blue' : 'red'}>{record.status == 0 ? '正常' : '停用'}</Tag>);
            },
          },
          {
            title: "备注",
            dataIndex: 'remark',
          },
          {
            title: "创建时间",
            dataIndex: 'createTime',
            width:'150px',
          },
        {
            title: '操作',
            width: '130px',
            render: (_, record) => {
                return <Space>
                <Link onClick={() => edit(record)}>
                    调整
                </Link>
                    
                <Link  onClick={() => deleteDict(record)}>
                    删除
                </Link>
            </Space>
            },
        },
    ];


    useEffect(() => {
        if(searchData.dictType){
            getList();
        }
    }, [searchData]);

    useEffect(() => {
        getAllDict();
        if(getSearchParams().dictType){
            setSearchData({
                ...pagingParam,
                dictType:getSearchParams().dictType
            })
            setOperationData({
                dictType:getSearchParams().dictType
            })
        }
    }, []);

    const getAllDict = async() => {
        try {
            const res = await Api.Dict.getOptionselect({});
            if(res && res.code === 0){
                setAllDict(res.data)
            }
        } catch (errInfo) {
            console.log('验证失败:', errInfo);
        }
    }

    const getList = async() => {
        setTableLoading(true);
        const res = await Api.Dict.getDictDataList({data:searchData});
        setTableLoading(false);
        if(res&&res.code === 0){
            let _data = res.data;
            setListData(_data.records);
            setEditingKey('');
            setPagination({
                "pageIndex": _data.current,
                "pageSize": _data.size,
                "total":_data.total
            });
        }else{
            setListData([]);
        }
    }

    // 修改
    const edit = (record) => {
        addForm.setFieldsValue({
            ...record,
            status:parseInt(record.status)
        });
        setEditingKey(record.dictCode);
        setIsModalOpen(true);
    };


    const onSearch = () => {
        let newSearchData = {
            ...searchData,
            ...operationData,
            pageIndex:1
        }
        setSearchData(newSearchData);
    }

    const onResetting = () => {
        setOperationData({
            dictType:getSearchParams().dictType
        });
        setSearchData({
            ...pagingParam,
            dictType:getSearchParams().dictType
        })
    }

    // 修改-保存
    const save = async (key) => {
        try {
            const row = await addForm.validateFields();
            row.dictCode = editingKey;
            setConfirmLoading(true);
            const res = await Api.Dict.updateDictData({data:row});
            if(res.code === 0){
                message.success("修改信息成功",2,()=>{
                    handleCancel();
                    getList();
                })
            }else{
                setConfirmLoading(false);
            }
        } catch (errInfo) {
            setConfirmLoading(false);
            console.log('验证失败:', errInfo);
        }
    };

    const deleteDict = (record) => {
        let ids = record.dictCode ? record.dictCode : selectedRowKey.join(',');
        if(ids){
            ModalConfirm({
                title: `您确认要删除字典编号为${ids}的数据项吗?`,
                onOk:async(resolve, reject)=> {
                    try{
                        const res = await Api.Dict.deleteDictData({data:ids});
                        resolve()
                        if(res&&res.code === 0){
                            getList();
                            setSelectedRowKey("");
                            message.success("删除成功")
                        }
                    }catch{}
                },
            })
        }else{
            message.info("请选择您需要删除的数据")
        }
    }

      // 新增
    const handleOk = async() => {
        if(editingKey){
            save() 
        }else{
            try {
                const row = await addForm.validateFields();
                setConfirmLoading(true);
                const res = await Api.Dict.addDictData({data:row});
                setConfirmLoading(false);
                if(res&&res.code === 0){
                    message.success("新增信息成功",2,()=>{
                        handleCancel();
                        getList();
                    })
                }
            } catch (errInfo) {
                setConfirmLoading(false);
                console.log('验证失败:', errInfo);
            }
        }
    }

    // 打开
    const addDict = () => {
       
        addForm.setFieldsValue({
            status:0,
            dictType:searchData.dictType
        });
        setIsModalOpen(true);
    }

    const handleCancel = () => {
        setConfirmLoading(false);
        setIsModalOpen(false);
        setEditingKey('');
    }


    const onChanges = (pagination, filters) => {
        let newSearchData = {...searchData}
        newSearchData.pageIndex = pagination.current;
        newSearchData.pageSize = pagination.pageSize;
        setSearchData(newSearchData);
    };

    const searchChange = (value, type) => {
        let newOperationData = {...operationData};
        newOperationData[type] = value;
        setOperationData(newOperationData)
    }
    
    return (
        <div className="dictFrame">
            <div className="operation" style={{padding: '0.5rem 1rem 0.5rem 1rem'}}>
                <div className="operationLeft">
                    <div className="operationItem">
                        <span className="inputTitle">字典名称：</span>
                        <Select
                            value={operationData.dictType} 
                            allowClear={true}
                            style={{
                                width: 120,
                            }}
                            onChange={(e)=>{
                                searchChange(e,"dictType")
                            }}
                            fieldNames={{ label: 'dictName', value: 'dictType' }}
                            options={allDict}
                        />
                    </div>
                    <div className="operationItem">
                        <span className="inputTitle">字典标签：</span>
                        <Input 
                            placeholder="输入字典类型" 
                            value={operationData.dictLabel} 
                            onChange={(e)=>{
                                searchChange(e.target.value,"dictLabel")
                            }}
                            allowClear={true}
                        />
                    </div>
                    <div className="operationItem">
                        <span className="inputTitle">状态：</span>
                        <Select
                            value={operationData.status} 
                            allowClear={true}
                            style={{
                                width: 120,
                            }}
                            onChange={(e)=>{
                                searchChange(e,"status")
                            }}
                            options={[
                                {
                                    value: 0,
                                    label: '正常',
                                },
                                {
                                    value: 1,
                                    label: '停用',
                                }
                            ]}
                        />
                    </div>
                    <Space size={"middle"}>
                        <Button type="primary" onClick={onSearch}>搜索</Button>
                        <Button onClick={onResetting}>重置</Button>
                    </Space>
                </div>

                <Space size={"large"}>
                    <Button type="primary" onClick={addDict}>添加字典</Button>
                    <Button type="primary" danger onClick={deleteDict}>删除字典</Button>
                </Space>
            </div>

            <BackIcon />
            <div className="table">
                <Form form={form} component={false}>
                    <SelfTable
                        rowKey={'dictCode'}
                        rowRadioSelection={{
                            type:'checkbox',
                            selectedRowKey:selectedRowKey,
                            setSelectedRowKey:setSelectedRowKey,
                        }}
                        pagination={pagination}
                        dataSource={listData}
                        columns={columns}
                        loading={tableLoading}
                        onChange={onChanges} 
                        isShowSort={false}
                    />
                </Form>
            </div>

            <Modal 
                title="添加字典数据" 
                open={isModalOpen} 
                onOk={handleOk} 
                onCancel={handleCancel}
                maskClosable={false}
                destroyOnClose={true}
                confirmLoading={confirmLoading}
            >
                <Form
                    form={addForm}
                    component={false}
                    labelCol={{ span: 6 }}
                    wrapperCol={{ span: 14 }}
                    preserve={false}
                >
                    <Form.Item
                        key={"dictType"}
                        label={"字典类型"}
                        name={"dictType"}
                    >
                        <Input disabled={true} />
                    </Form.Item>
                    <Form.Item
                        key={"dictLabel"}
                        label={"数据标签"}
                        name={"dictLabel"}
                        rules={[{ required: true, message: `请输入数据标签!` }]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        key={"dictValue"}
                        label={"数据键值"}
                        name={"dictValue"}
                        rules={[{ required: true, message: `请输入数据键值!` }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        key={"cssClass"}
                        label={"样式属性"}
                        name={"cssClass"}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        key={"dictSort"}
                        label={"显示排序"}
                        name={"dictSort"}
                        rules={[{ required: true, message: `请输入显示排序!` }]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        key={"listClass"}
                        label={"回显样式"}
                        name={"listClass"}
                    >
                        <Select
                            allowClear={true}
                            options={[
                                {value: "default",label: '默认(default)',},
                                {value: "processing",label: '主要(primary)',},
                                {value: 'success',label: '成功(success)',},
                                {value: "warning",label: '警告(warning)',},
                                {value: "error",label: '危险(danger)',}
                            ]}
                        />
                    </Form.Item>
                    <Form.Item
                        key={"status"}
                        label={"状态"}
                        name={"status"}
                    >
                        <Radio.Group>
                            <Radio value={0}>正常</Radio>
                            <Radio value={1}>停用</Radio>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item
                        key={"remark"}
                        label={"备注"}
                        name={"remark"}
                    >
                        <TextArea
                            style={{
                                height: 120,
                            }}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </div>
    );
};
export default Dict;
